import Amplify from 'aws-amplify';
// @ts-ignore
import awsExports from '../aws-exports.js';

Amplify.configure(awsExports);
